import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import { fromAccounts } from '../../store';
import { useLaunchDarkly } from '../../launchdarkly';
import { Order } from '../../models';
import { useNavigate } from '../../routes';
import { confirmPayment } from '../../layout/routes';

export interface CompletePaymentProps {
  order: Order;
}

export const CompletePayment = (props: CompletePaymentProps) => {
  const { order } = props;
  const { replace, replaceQuery } = useNavigate();
  const { flags } = useLaunchDarkly();
  const selectedAccount = useSelector(fromAccounts.selectSelectedAccount);

  const completePayment = () => {
    if (flags?.usingStripeCheckoutSession) {
      // Use Stripe Checkout Session flow
      window.open(order.stripeInvoiceUrl, '_blank');
    } else {
      // Navigate to Confirmation Payment page
      replace(confirmPayment.path, replaceQuery({
        accountId: selectedAccount?.id,
        orderId: order.id.toString(),
      }));
    }
  };

  return (
    <Button
      id="complete-payment-btn"
      variant="contained"
      onClick={completePayment}
      sx={theme => ({
        height: theme.spacing(5),
        backgroundColor: '#5959EB',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#43509B',
        },
      })}
    >
      <FormattedMessage
        id="pending.order.complete.payment"
      />
    </Button>
  );
};
